// Maps game element types to their RoomState collection keys.
import { GameElementType } from '../types';
const gameElementCollectionByType = {
    [GameElementType.TURN]: 'turns',
    [GameElementType.PROMPT]: 'prompts',
    [GameElementType.ANSWER]: 'answers',
    [GameElementType.VOTE]: 'votes',
};
export function getGameElementCollectionKey(elementType) {
    return gameElementCollectionByType[elementType];
}
//# sourceMappingURL=getGameElementCollectionKey.js.map